import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";
import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";

import MiniModelBox from "components/Business/ModelBox/MiniModelBox";

class ModelBoxContainer extends React.PureComponent {
  render() {
    return <MiniModelBox {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  const retId = ownProps.runId;

  return {
    initRun: () => {},
    updateCurrentStep: (stepId) => dispatch(businessReducer.updateCurrentStep(id, stepId)),
    updateShowBusiness: (showBusiness) => dispatch(setupReducer.updateShowBusiness(retId, showBusiness)),
    updateShowImpact: (showImpact) => dispatch(setupReducer.updateShowImpact(retId, showImpact)),
    updateTimePeriod: (timePeriod) => dispatch(updateTimePeriod(id, timePeriod)),
    deploy: () => dispatch(projectReducer.deploy(id, true)),
    updateDrilldownValue: (runId, drilldownValue) =>
      dispatch(projectReducer.updateDrilldownValue(id, runId, drilldownValue)),
    selectStep: (step) => dispatch(businessReducer.selectStep(ownProps.id, step)),

    viewScenario: (scenario, index) => dispatch(projectReducer.viewScenario(id, scenario, index)),
    deleteScenario: () => dispatch(projectReducer.deleteScenario(id)),

    saveScenario: (name) => dispatch(projectReducer.saveScenario(id, name)),
    shortlistScenario: () => dispatch(projectReducer.shortlistScenario(id))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  let optimized = ownProps.optimized;
  if (!optimized || Number(optimized.id) !== Number(id)) {
    optimized = projectReducer.getOptimized(state, id);
  }

  const overallRunId = projectReducer.getOverallRunId(state, id);

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  const overallOptimized = overallRunId === runId ? optimized : projectReducer.getOptimized(state, id, overallRunId);

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || Number(modelGroups.id) !== Number(id)) {
    modelGroups = projectReducer.getModelGroups(state, id);
  }

  return {
    id: id,
    runId: runId,
    currentStep: businessReducer.getCurrentStep(state, ownProps.id),

    isOverallSegment: projectReducer.getIsOverallSegment(state, id),

    modelGroups: modelGroups,
    isScenarioDeployed: projectReducer.getIsScenarioDeployed(state, id),
    project: projectReducer.getProject(state, id),
    optimized: optimized,
    overallOptimized: overallOptimized,

    isTraining: projectReducer.getIsTraining(state, id),

    segmentConfusionMatrices: projectReducer.getSegmentConfusionMatrices(state, id),

    isContinuous: setupReducer.getIsContinuous(state, runId),

    transactionLabel: setupReducer.getTransactionLabel(state, runId),
    outcomeLabel: setupReducer.getOutcomeLabel(state, runId),
    notPursuedTransactionLabel: setupReducer.getNotPursuedTransactionLabel(state, runId),
    trueAction: setupReducer.getTrueAction(state, runId),
    falseAction: setupReducer.getFalseAction(state, runId),
    unitType: setupReducer.getUnitType(state, runId),
    revenueLabel: setupReducer.getAdvancedRevenueLabel(state, runId),
    profitLabel: setupReducer.getNetImpactLabel(state, runId),
    costLabel: setupReducer.getAdvancedCostLabel(state, runId),
    truePositiveLabel: setupReducer.getTruePositiveLabel(state, runId),
    setupLabels: setupReducer.getSetupLabels(state, runId),
    rSetup: setupReducer.getSetup(state, id),

    setup: optimized && optimized.setup ? optimized.setup : setupReducer.getSetup(state, id),
    overallSetup: setupReducer.getSetup(state, overallRunId),
    model: projectReducer.getCapModel(state, id, runId),
    modelList: runReducer.getTransformedSortedModels(state, runId),
    primaryBusinessConstraintType: setupReducer.getPrimaryBusinessConstraintType(state, id, runId),
    allBusinessConstraints: setupReducer.getAllBusinessConstraints(state, id),

    showImpact: setupReducer.getShowImpact(state, id),

    nextModelsHoverNode: nextModelsReducer.getHoverNode(state, ownProps.nextId),

    selectedScenario: projectReducer.getSelectedScenario(state, id),
    allScenarios: projectReducer.getAllScenarios(state, id),
    optimizer: projectReducer.getOptimizer(state, id),
    currentCostExcludingBaselines: projectReducer.getCurrentSpendExcludingBaselines(state, id, overallRunId),
    currentRevenueExcludingBaseline: projectReducer.getCurrentRevenueExcludingBaselines(state, id, overallRunId),
    currentProfitExcludingBaseline: projectReducer.getCurrentProfitExcludingBaselines(state, id, overallRunId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelBoxContainer);
